export enum LocalMessagePauseReasonType {
  DocumentHidden = 'document-hidden',
  // the overlay is not mounted yet (splash) or was unmounted
  RendererDetached = 'renderer-detached',
}
